import { writable } from 'svelte/store';

export const authenticationState = writable(null);

// TODO: https://auth0.com/docs/security/store-tokens
export const accessToken = writable(null);
export const user = writable(null);
// Check this out: https://svelte.dev/tutorial/custom-stores
